import { gql } from '@apollo/client';

// ============================================================================
// QUERIES
// ============================================================================

export const MIS_PROPIEDADES = gql`
  query MisPropiedades {
    misPropiedades {
      id
      nombre
      nombre_corto
      nit
      direccion
      ciudad
      departamento
      telefono
      email
      logo_url
      color_primario
      color_secundario
      activo
      rol_usuario
    }
  }
`;

export const GET_PROPIEDAD = gql`
  query GetPropiedad($id: Int!) {
    propiedad(id: $id) {
      id
      nombre
      nombre_corto
      nit
      direccion
      ciudad
      departamento
      telefono
      email
      logo_url
      color_primario
      color_secundario
      timezone
      activo
      created_at
    }
  }
`;

export const TODAS_PROPIEDADES = gql`
  query TodasPropiedades {
    todasPropiedades {
      id
      nombre
      nombre_corto
      nit
      ciudad
      activo
      created_at
    }
  }
`;

export const USUARIOS_PROPIEDAD = gql`
  query UsuariosPropiedad($propiedad_id: Int!) {
    usuariosPropiedad(propiedad_id: $propiedad_id) {
      id
      nombre
      apellido
      usuario
      email
      telefono
      foto_url
      activo
      rol
      asignacion_activa
      asignado_desde
    }
  }
`;

// ============================================================================
// MUTATIONS
// ============================================================================

export const CREAR_PROPIEDAD = gql`
  mutation CrearPropiedad($input: CrearPropiedadInput!) {
    crearPropiedad(input: $input) {
      id
      nombre
      nombre_corto
      ciudad
      activo
    }
  }
`;

export const ACTUALIZAR_PROPIEDAD = gql`
  mutation ActualizarPropiedad($id: Int!, $input: ActualizarPropiedadInput!) {
    actualizarPropiedad(id: $id, input: $input) {
      id
      nombre
      nombre_corto
      nit
      direccion
      ciudad
      departamento
      telefono
      email
      logo_url
      color_primario
      color_secundario
      timezone
      activo
    }
  }
`;

export const ELIMINAR_PROPIEDAD = gql`
  mutation EliminarPropiedad($id: Int!) {
    eliminarPropiedad(id: $id)
  }
`;

export const ASIGNAR_USUARIO_PROPIEDAD = gql`
  mutation AsignarUsuarioPropiedad($usuario_id: Int!, $propiedad_id: Int!, $rol: String!) {
    asignarUsuarioPropiedad(usuario_id: $usuario_id, propiedad_id: $propiedad_id, rol: $rol) {
      id
      usuario_id
      propiedad_id
      rol
      activo
    }
  }
`;

export const REMOVER_USUARIO_PROPIEDAD = gql`
  mutation RemoverUsuarioPropiedad($usuario_id: Int!, $propiedad_id: Int!) {
    removerUsuarioPropiedad(usuario_id: $usuario_id, propiedad_id: $propiedad_id)
  }
`;
